import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text, TextFontSizes, TextFontWeights, TextLineHeights } from "@cinch-labs/design-system";
import styles from "./how-it-works.module.css";
const HowItWorksStep = ({ i18n , Image , children  })=>/*#__PURE__*/ _jsxs("li", {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.howItWorksImage,
                children: /*#__PURE__*/ _jsx(Image, {
                    "aria-hidden": "true"
                })
            }),
            /*#__PURE__*/ _jsx(Text, {
                className: styles.howItWorksTitle,
                element: "h3",
                fontSize: TextFontSizes.l,
                fontWeight: TextFontWeights.bold,
                lineHeight: TextLineHeights.display,
                children: i18n.title
            }),
            children ? children : /*#__PURE__*/ _jsx(Text, {
                fontSize: TextFontSizes.m,
                fontWeight: TextFontWeights.book,
                children: i18n.text
            })
        ]
    });
export default HowItWorksStep;
